import _ from 'lodash';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { selectTerm, loadFavourites, saveFavourites, addFavourite, removeFavourite } from '../actions';
import audioIcon from '../../assets/images/icon_audio.svg';

let audio;

class Description extends Component {

    componentDidMount(){
        this.props.loadFavourites();
    }

    isFavourite(term){
        for (let i = 0; i < this.props.favouritesList.length; i++){
            if(
                this.props.favouritesList[i].termName === term.termName &&
                this.props.favouritesList[i].age_group === term.age_group
            ){
                return true;
            }
        }
        return false;
    }

    toggleFavourite(term){
        if(this.isFavourite(term)){
            this.props.removeFavourite(term);

        } else {
            this.props.addFavourite(term);
        }
        this.props.saveFavourites(this.props.favouritesList);
        this.props.loadFavourites();
    }

    playAudio(term){
        if(term.sound !== '1'){
            return
        }

        const country = this.props.country;

        if (audio && !audio.paused) {
            audio.pause();
        } else {
            const baseUrl = `${this.props.baseUrl}/sound/`;
            audio = new Audio(baseUrl + 'terms/' + country + '/level' + term.age_group + '/' + term.file_resource + '.mp3');

            audio.play();
            audio.addEventListener('ended', function (e) {
                audio = new Audio(baseUrl + country + '/level' + term.age_group + '/' + term.file_resource + '.mp3');
                audio.play();
            }, false);
        }
    }

    render(){
        const term = this.props.selectedTerm;
        let desc = '';
        if (!term){
            desc = '';
        } else {
            desc = decodeURIComponent(term.desc);
        }

        if(desc === 'undefined') {
            desc = '';
        }

        if(!term || desc === ''){
            return (
              <div className="description-div"></div>
            );
        } else {
            return(
                <div className="description-div">
                    <span
                        className="description-text"
                        dangerouslySetInnerHTML={{
                            __html: desc
                        }}
                    ></span>
                    <p className="term-text">{term.termName}</p>

                    <button
                        className={ this.isFavourite(term) ? 'btn-default  fav-star fav-star-on' : 'btn-default fav-star'}
                        onClick={ () => { this.toggleFavourite(term) }}>

                    </button>

                    <button className={ term.sound === '1' ? 'btn-default speech enable' : 'btn-default speech disable' }
                            disabled={ term.sound !== '1'}
                            onClick={
                                () => { this.playAudio(term) }
                            }>
                              <img alt="audio icon" src={audioIcon} />
                    </button>
                </div>
            );
        }
    }
}


function mapStateToProps(state){
    return {
        selectedTerm: state.mathsDictionary.selectedTerm,
        country: state.mathsDictionary.countryFilter,
        favouritesList: state.favourites.favouritesList,
        baseUrl: state.mathsDictionary.baseUrl
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        selectTerm,
        addFavourite,
        removeFavourite,
        loadFavourites,
        saveFavourites
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Description);

